var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ResponseService = /** @class */ (function () {
    function ResponseService(optionService) {
        this.allowedExtensions = [
            'gs', 'hbs', 'ejs',
        ];
        this.optionService = optionService;
    }
    ResponseService.prototype.setErrors = function (errors, override) {
        if (override === void 0) { override = false; }
        this.optionService.setRoutingErrors(errors, override);
    };
    ResponseService.prototype.send = function (content) {
        if (content instanceof Object)
            return this.json(content);
        return this.html(content);
    };
    ResponseService.prototype.html = function (html) {
        return HtmlService.createHtmlOutput(html);
    };
    ResponseService.prototype.render = function (template, data, viewEngine) {
        if (data === void 0) { data = {}; }
        if (viewEngine === void 0) { viewEngine = 'raw'; }
        if (typeof template === 'string') {
            var fileName = template;
            var views = this.optionService.get('views');
            var fileExt = template.split('.').pop();
            fileExt = (this.allowedExtensions.indexOf(fileExt) > -1) ? fileExt : null;
            if (fileExt) {
                viewEngine = fileExt;
            }
            template = HtmlService.createTemplateFromFile((views ? views + '/' : '') + fileName);
        }
        // render accordingly
        var templateText = template.getRawContent();
        var outputHtml;
        if (viewEngine === 'native' || viewEngine === 'gs') {
            try {
                for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                    var key = _a[_i];
                    template[key] = data[key];
                }
                // NOTE: somehow this doesn't work
                outputHtml = template.evaluate().getContent();
            }
            catch (error) {
                outputHtml = templateText;
            }
        }
        else if (viewEngine === 'handlebars' || viewEngine === 'hbs') {
            var render = Handlebars.compile(templateText);
            outputHtml = render(data);
        }
        else if (viewEngine === 'ejs') {
            outputHtml = ejs.render(templateText, data);
        }
        else {
            outputHtml = templateText;
        }
        return this.html(outputHtml);
    };
    ResponseService.prototype.json = function (object) {
        var JSONString = JSON.stringify(object);
        var JSONOutput = ContentService.createTextOutput(JSONString);
        JSONOutput.setMimeType(ContentService.MimeType.JSON);
        return JSONOutput;
    };
    ResponseService.prototype.success = function (data, meta) {
        if (meta === void 0) { meta = {}; }
        if (!data)
            return this.error();
        if (!(data instanceof Object)) {
            data = { value: data };
        }
        if (!(meta instanceof Object)) {
            meta = { value: meta };
        }
        var success = {
            success: true,
            status: 200,
            data: data,
            meta: __assign({ at: (new Date()).getTime() }, meta)
        };
        return this.json(success);
    };
    ResponseService.prototype.error = function (err, meta) {
        if (meta === void 0) { meta = {}; }
        var responseError;
        if (typeof err === 'string') { // a string
            // build response erro from routing errors
            var code = err;
            var errors = this.optionService.getRoutingErrors();
            var error = errors[code];
            if (!error) {
                error = { message: code };
                code = null;
            }
            else {
                error = (typeof error === 'string') ? { message: error } : error;
            }
            // return a response error
            var _a = error, status = _a.status, message = _a.message;
            responseError = { code: code, message: message, status: status };
        }
        else { // a ResponseError
            responseError = err || {};
        }
        if (!responseError.status)
            responseError.status = 500;
        if (!responseError.code)
            responseError.code = 'app/internal';
        if (!responseError.message)
            responseError.message = 'Unknown error.';
        if (!(meta instanceof Object)) {
            meta = { value: meta };
        }
        return this.json(__assign({}, responseError, { error: true, meta: __assign({ at: (new Date()).getTime() }, meta) }));
    };
    return ResponseService;
}());
export { ResponseService };
